export const SELECT_DESIGN = 'ui/SELECT_DESIGN';
export const TOGGLE_THANKS_PAGE = 'ui/TOGGLE_THANKS_PAGE';

export default {
  selectDesign: id => ({ type: SELECT_DESIGN, payload: { id } }),
  toggleThanksPage: () => ({ type: TOGGLE_THANKS_PAGE })
};



// WEBPACK FOOTER //
// ./src/actions/ui.js